/** TanStack Query keys for Cova Chat. First element is the otel span name. */
export const chatKeys = {
  all: ["chat"],
  conversations: ["chat", "conversations"],
  messages: (conversationId: string) => ["chat", "messages", conversationId],
  unread: ["chat", "unread"],
  members: (conversationId: string) => ["chat", "members", conversationId],
  // Prefix of use-live-meeting's key (which appends a `scope`); an invalidate on
  // this prefix matches the scoped key, so realtime pushes can refresh meetings.
  meetings: (conversationId: string) => ["chat", "meetings", conversationId],
} as const
